/**
 * Applies Bootstrap 4 classes to all elements inside a container.
 * Designed for use on dangerouslySetInnerHTML content where raw HTML
 * (e.g. from CKEditor or Kaplan OWA imports) needs consistent styling.
 * All text content is forced left-aligned.
 */
export function applyBootstrapStyles(el) {
  if (!el) return

  const rules = [
    { selector: 'table',   classes: ['table', 'table-bordered', 'table-sm', 'text-left'] },
    { selector: 'thead',   classes: ['thead-light'] },
    { selector: 'img',     classes: ['img-fluid', 'd-block'] },
    { selector: 'ul',      classes: ['pl-4', 'text-left'] },
    { selector: 'ol',      classes: ['pl-4', 'text-left'] },
    { selector: 'p',       classes: ['text-left'] },
    { selector: 'div',     classes: ['text-left'] },
    { selector: 'h1,h2,h3,h4,h5,h6', classes: ['text-left'] },
    { selector: 'blockquote', classes: ['blockquote', 'pl-3', 'border-left', 'text-left'] },
    { selector: 'pre',     classes: ['pre-scrollable', 'p-2', 'bg-light', 'border', 'rounded'] },
    { selector: 'a',       classes: ['text-left'] },
  ]

  for (const { selector, classes } of rules) {
    el.querySelectorAll(selector).forEach(node => {
      node.classList.add(...classes)
    })
  }
}
